const NoMatch = () => {
  return (
    <h3 style={{ marginTop: "200px" }}>
      Sorry! We did not find the page you've been looking for ...!!
    </h3>
  );
};

export default NoMatch;
